// export const API_URL = 'https://o824zq2v0e.execute-api.us-east-1.amazonaws.com/dev';
// export const API_URL = 'https://esxx8sj2eb.execute-api.us-east-1.amazonaws.com/prodnext';
// export const API_URL = 'http://0.0.0.0:3010/dev';

const isProd = process.env.NODE_ENV === 'production' || (global as any).prod;

export const API_URL = isProd
  ? 'https://1yxmvuaa7d.execute-api.us-east-1.amazonaws.com/prod'
  : 'http://localhost:3010/dev';

export const SOLANA_CONFIG =
  !(global as any).tf && isProd
    ? {
        NET: 'mainnet-beta',
        SCAN_URL: 'https://solscan.io/tx/{{transactionId}}',
      }
    : {
        NET: 'devnet',
        SCAN_URL: 'https://solscan.io/tx/{{transactionId}}?cluster=devnet',
      };

export const DISCORD_LINK = 'https://discord.gg/2EZvT7P';
export const REPORT_A_BUG_LINK = 'https://discord.gg/UsH4Nvy';
export const HELP_LINK = 'https://discord.gg/Q6PAYeh';
export const APP_STORE_LINK = 'https://itunes.apple.com/gb/app/stormfire/id1391894511?mt=8';
export const PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=com.butuzgol.stormfire';
export const PRIVACY_POLICY_LINK =
  'https://termsfeed.com/privacy-policy/4b041683296ff8032b97c3be3beee3cb';
export const PATREON_LINK = 'https://www.patreon.com/stormfiregame';
export const INVITE_LINK_BASE = 'https://stormfire.net/?invitedBy=';

export const AD_REWARD_PER_LEVEL = 5;
export const AD_VIEWS_DAILY_CAP = 5;

export const CONTACT_EMAIL = 'butuzgol@gmail.com';

export const DONATIONS = [
  { name: 'Bitcoin', address: 'bc1qy6wfll4yd4wksqvyhpnkkwave8qpf05meud6nw' },
  { name: 'Ethereum', address: '0x99693aEeEEb168a2a3D432Db5b4d2f9f8e01519e' },
  { name: 'Solana', address: 'CTPKt7qqExAKxGUihvNpfvkuBiY8s9K68QCnRRrvYjRL' },
];

export const FIREBASE_DEV = {
  apiKey: 'AIzaSyAXUAP7jOwq82TuWNT2Igfhk4kI75lvgRY',
  authDomain: 'game-dev-7995e.firebaseapp.com',
  databaseURL: 'https://game-dev-7995e.firebaseio.com',
  projectId: 'game-dev-7995e',
  storageBucket: 'game-dev-7995e.appspot.com',
  messagingSenderId: '5242730737',
};

export const FIREBASE = {
  apiKey: 'AIzaSyBsmYFZJdB3lL-zcJqjIvwk4Ax3e5HNsxM',
  authDomain: 'game-2662d.firebaseapp.com',
  databaseURL: 'https://game-2662d.firebaseio.com',
  projectId: 'game-2662d',
  storageBucket: 'game-2662d.appspot.com',
  messagingSenderId: '341966352239',
};

export const FIREBASE_CONFIG = !(global as any).devDb ? FIREBASE : FIREBASE_DEV;

export const STORAGE_URL = `https://firebasestorage.googleapis.com/v0/b/${FIREBASE_CONFIG.storageBucket}/o`;

export const FACEBOOK = {
  appId: '1143107352367685',
  cookie: true,
  xfbml: true,
  version: 'v3.1',
};

export const WARRIOR_DEFAULT = {
  money: 0.0,
  moneyArt: 0.0,

  strength: 3,
  dexterity: 3,
  intuition: 3,
  health: 3,

  swords: 0,
  axes: 0,
  knifes: 0,
  clubs: 0,
  shields: 0,

  numberOfAbilities: 0,
  numberOfParameters: 0,

  strikeCount: 1,
  blockCount: 2,

  location: {
    island: '0',
    coordinateX: 26,
    coordinateY: 16,
  },
};

export const COEFFICIENTS = {
  damageMin: 2,
  damageMax: 3,

  accuracy: 2,
  dodge: 2.5,
  devastate: 2.5,
  durability: 2,

  hp: 10,

  capacity: 10,

  arms: 5,
  protection: 5,
};

export const ISLAND_MOVE_TIME = 0.5;

export const COMBAT_RANGE = {
  dodge: 150,
  devastate: 150,
  blockBreak: 150,
  armorBreak: 150,
  damage: 30,
};

export const COMBAT_DODGE_BALANCER = 2;

export const MIN_DAMAGE_IF_ZERO = 3;

export const EXPERIENCE_DIFF_DELTA = 10;
export const EXPERIENCE_MINUS_DELTA = 800;

export const HP_DELAY = 50;

export const THINGS_EVAL_STABILITY_PERCENT = 20;
export const THINGS_MIN_STABILITY_WARNING = 2;
export const THINGS_MIN_STABILITY_WARNING_NOT_DRESSABLE = 1;
export const BUILDINGS_FORGE_REPAIR_COST = 0.1;

export const MONEY_GIVE_DELTA = 2;
export const THINGS_GIVE_DELTA = 3;

export const IS_ONLINE_ACTION_TIME_LIMIT = 60 * 60;

export const DRESSED_RINGS_COUNT = 4;
export const DRESSED_UNDRESSABLE_COUNT = 10;

export const MIN_LVL_TO_SEND = 1;

export const CLAN = {
  MAX_MEMBERS: 20,
  MIN_LEVEL_TO_CREATE: MIN_LVL_TO_SEND,
  CREATION_COST: 1000,
  NAME_MIN: 3,
  NAME_MAX: 20,
  TAG_MIN: 2,
  TAG_MAX: 4,
  // How long the war lobby stays open before it can be started / auto-cancels (ms).
  WAR_LOBBY_MS: 5 * 60 * 1000,
  TOP_CLANS_LIMIT: 20,
};
